import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Box, theme } from "@xometry/xometry_loft";

export const Italic = css`
  font-style: italic;
`;

export const Section = css`
  margin: 8px 0;
  span {
    font-weight: ${theme.fontWeights.light};
  }
`;

export const ShortText = css`
  ${theme.mediaQueries.medium} {
    min-width: 190px;
  }
`;

export const FullWidth = css`
  width: 100%;
  select {
    width: 100%;
  }
`;

export const CheckboxGroup = css`
  display: grid;
`;

export const RadioGroup = css`
  display: grid;
  > div {
    margin-bottom: ${theme.space[2]};
  }
  label {
    display: inline;
    margin-left: ${theme.space[2]};
    font-size: ${theme.fontSizes[2]};
    font-weight: normal;
    line-height: unset;
  }
`;

export const InlineLabelInput = css`
  display: inline-block;
  label {
    display: inline-block !important;
  }
`;

export const TooltipWrapper = styled(Box)`
  display: inline-block;
  margin-left: ${theme.space[1]};
  color: ${theme.colors.blues[100]};
  white-space: pre-wrap;
  flex-grow: 1;
`;
